import { intervalToDuration } from 'date-fns-jalali';
import { useEffect, useMemo, useState } from 'react';
type Duration = {
  years?: number | string;
  months?: number | string;
  weeks?: number | string;
  days?: number | string;
  hours?: number | string;
  minutes?: number | string;
  seconds?: number | string;
};
const defaultDuration: Duration = {
  years: '-',
  months: '-',
  weeks: '-',
  days: '-',
  hours: '-',
  minutes: '-',
  seconds: '-'
};
export type TimerProps = {
  time: Date | string | undefined;
  onDone?: () => void;
  children: (duration: Duration) => JSX.Element;
};
export function Timer({
  onDone,
  time: propsTime,
  children
}: TimerProps) {
  const [duration, setDuration] = useState<Duration>(defaultDuration);
  const targetTime = useMemo(() => {
    return propsTime ? new Date(propsTime).getTime() : null;
  }, [propsTime]);
  useEffect(() => {
    if (!targetTime) return;
    let interval: ReturnType<typeof setInterval> | null = null;
    const updateDuration = () => {
      const now = new Date().getTime();
      if (targetTime <= now) {
        onDone?.();
        if (interval) {
          clearInterval(interval);
        }
      } else {
        setDuration(intervalToDuration({
          start: now,
          end: targetTime
        }));
      }
    };
    interval = setInterval(updateDuration, 1000);
    updateDuration(); // Initial call to set duration immediately

    return () => clearInterval(interval);
  }, [onDone, targetTime]);
  return children(duration);
}